<template>
  <WdsStack direction-row gap-sm class="loading-container">
    <Skeleton v-if="avatar" class="loading-square" />

    <WdsStack direction-column gap-sm class="tw-flex-1">
      <Skeleton class="loading" />

      <Skeleton class="loading-secondary" />
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import { defineProps, withDefaults } from 'vue'

import Skeleton from './Skeleton.vue'

withDefaults(defineProps<{ avatar?: boolean }>(), {
  avatar: false,
})
</script>

<style lang="scss" scoped>
.loading-container {
  @apply tw-w-full;
  @apply tw-bg-white;
  @apply tw-rounded;
  @apply tw-py-1;
  @apply tw-p-3;
  @apply tw-px-4;
  @apply tw-mt-2;
  @apply tw-flex;
  @apply tw-items-center;
}

.loading-square {
  @apply tw-w-[46px];
  @apply tw-h-[46px];
  @apply tw-rounded-lg;
}

.loading {
  @apply tw-w-3/5;
  @apply tw-h-[20px];
  @apply tw-rounded-xl;
}

.loading-secondary {
  @apply tw-w-2/5;
  @apply tw-h-[20px];
  @apply tw-bg-gray-100;
  @apply tw-rounded-xl;
}
</style>
